import {CoreSettings, EnvironmentMandant, Language} from '@lv1871/core';

export const environment: CoreSettings  = {
  production: true,
  translationLanguage: Language.DE,
  mandant: EnvironmentMandant.LV,
  app_root_url: '',
  api: {
    middlewareUrl: 'https://middleware-test.lv1871.de',
    googleTagManagerId: '',
    googleUAId: '',
  },
  config: {
    environmentName: 'staging',
    environmentMode: 'Build-Time: <%= buildTime %>',
    showEnvironmentInfo: false,
    useGoogleTagManager: false,
    askForLeavingPage: false,
  }
};
